import { render, staticRenderFns } from "./Pluck.vue?vue&type=template&id=1b6f112b&scoped=true"
import script from "./Pluck.vue?vue&type=script&lang=js"
export * from "./Pluck.vue?vue&type=script&lang=js"
import style0 from "./Pluck.vue?vue&type=style&index=0&id=1b6f112b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6f112b",
  null
  
)

export default component.exports